import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { appInsights } from '../ai/AppInsights';
import { types } from '../actions/jobs';

const initialState = {
  pendingFlag: false,
  error: '',
  response: null,
  pagination: {
    PageNumber: 1,
    PageSize: 10,
    TotalPages: 0
  },
  recommendedJobs: [],
  counters: {
    AppliedJobs: 0,
    SavedJobs: 0,
    TotalJobs: 0,
    Inquiries: null
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_JOBS_FULFILLED:
    case types.FETCH_SAVED_JOBS_FULFILLED:
    case types.FETCH_APPLIED_JOBS_FULFILLED:
    case types.FETCH_JOBS_PUBLIC_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        error: '',
        response: action.payload?.Data,
        pagination: action.payload?.Pagination
      };
    case types.FETCH_JOBS_PENDING:
    case types.FETCH_SAVED_JOBS_PENDING:
    case types.FETCH_APPLIED_JOBS_PENDING:
    case types.FETCH_RECOMENDED_JOBS_PENDING:
    case types.FETCH_JOBS_PUBLIC_PENDING:
      return { ...state, pendingFlag: true, error: '' };
    case types.FETCH_JOBS_REJECTED:
    case types.FETCH_SAVED_JOBS_REJECTED:
    case types.FETCH_APPLIED_JOBS_REJECTED:
    case types.FETCH_JOBS_PUBLIC_REJECTED:
      appInsights.trackException({
        error: new Error(action.payload.message),
        severityLevel: SeverityLevel.Error
      });
      return { ...state, pendingFlag: false, error: action.payload.message };
    case types.CHANGE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          PageNumber: action.payload
        }
      };
    case types.FETCH_RECOMENDED_JOBS_FULFILLED:
      return { ...state, recommendedJobs: action.payload.Data || [], pendingFlag: false, error: '' };
    case types.GET_COUNTERS_FULFILLED:
      return { ...state, counters: action.payload.Data };
    case types.SET_APPLIED_JOB:
      return {
        ...state,
        response: state.response
          ? state.response.map((item) => (item.Id !== action.payload ? item : { ...item, IsApplied: true }))
          : state.response
      };
    case types.SAVE_JOB_FULFILLED:
      return {
        ...state,
        response:
          state.response && action.payload.Data
            ? state.response.map((item) => (item.Id !== action.payload.jobId ? item : { ...item, IsSaved: true }))
            : state.response,
        counters: { ...state.counters, SavedJobs: state.counters.SavedJobs + 1 }
      };
    case types.REMOVE_SAVED_JOB_FULFILLED:
      return {
        ...state,
        response:
          state.response && action.payload.Data
            ? state.response.map((item) => (item.Id !== action.payload.jobId ? item : { ...item, IsSaved: false }))
            : state.response,
        counters: { ...state.counters, SavedJobs: state.counters.SavedJobs - 1 }
      };
    case types.REMOVE_SAVED_JOB_SAVED_FULFILLED:
      return {
        ...state,
        response:
          state.response && action.payload.Data
            ? state.response.map((item) => (item.JobId !== action.payload.jobId ? item : false)).filter(Boolean)
            : state.response,
        counters: { ...state.counters, SavedJobs: state.counters.SavedJobs - 1 }
      };
    default:
      return state;
  }
}
